<template>
  <transition name="el-fade-in-linear">
    <div
      v-show="dialogVisible"
      class="popContainer indiv-pop"
    >
      <div class="indiv-pop-center">
        <span
          class="indiv-pop-close iconfont icon-close_round_fill_bold"
          role="button"
          aria-label="关闭"
          @click="onClose"
        ></span>
        <div class="indiv-pop-box realname-record-pop">
          <div class="indiv-pop-title">实名记录</div>
          <div
            v-loading="loading"
            class="indiv-pop-body realname-record-pop__body"
            element-loading-text="加载中..."
          >
            <ul v-if="info" class="record-list">
              <li class="record-row">
                <span class="record-label">认证状态</span>
                <span class="record-value">{{ info.realnameStatusText || '已认证' }}</span>
              </li>
              <li class="record-row">
                <span class="record-label">真实姓名</span>
                <span class="record-value">{{ info.relName || '—' }}</span>
              </li>
              <li class="record-row">
                <span class="record-label">身份证号</span>
                <span class="record-value">{{ info.idCard || '—' }}</span>
              </li>
              <li class="record-row">
                <span class="record-label">手机号</span>
                <span class="record-value">{{ info.realnamePhone || '—' }}</span>
              </li>
              <li class="record-row">
                <span class="record-label">认证时间</span>
                <span class="record-value">{{ info.realnameTime || '—' }}</span>
              </li>
            </ul>
          </div>
          <div class="indiv-pop-foot">
            <button type="button" class="indiv-pop-btn" @click="onClose">
              我知道了
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  fetchRealnameStatus,
  isRealnameVerified,
} from './realnameService';

export default {
  name: 'RealnameRecordDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      info: null,
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },

  watch: {
    visible(val) {
      if (val) {
        this.loadInfo();
      }
    },
  },

  methods: {
    loadInfo() {
      this.loading = true;
      this.info = null;
      fetchRealnameStatus()
        .then((status) => {
          if (status && isRealnameVerified(status)) {
            this.info = status;
            return;
          }
          this.$message.info('暂无实名认证记录');
          this.dialogVisible = false;
        })
        .catch(() => {
          this.$message.error('获取实名信息失败');
          this.dialogVisible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.realname-record-pop {
  width: 480px;
  max-width: calc(100vw - 48px);
}

.realname-record-pop__body {
  min-height: 200px;
  padding: 24px 40px 8px;
}

.record-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.record-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 14px 0;
  font-size: 14px;
  line-height: 22px;
}

.record-label {
  flex: 0 0 72px;
  color: #999;
}

.record-value {
  flex: 1;
  min-width: 0;
  color: #333;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/view/user/realname/RealnameRecordDialog.vue